import { isNullish } from "../../util/common-util";
import { z } from "zod";
import { ValueObjectMetaComposite } from "../meta";
import { predefinedMessageIds } from "../../../predefined-message-ids";
import { messageId } from "../../types";

/**
 * 日付(値オブジェクト)
 *
 * 日付。 */
const regex = /^(\d+)-(\d+)-(\d+)$/;
const preprocess = (item: any) => {
  if (typeof item !== "string") return item;
  const m = item.match(regex);
  if (isNullish(m)) return item;
  // log.debug(
  //   `predefinedYearMonthDayMeta: preprocess: m=${JSON.stringify(
  //     m,
  //   )}, parseInt(m[1], 10)=${parseInt(m[1], 10)}`,
  // );
  return {
    year: parseInt(m[1], 10),
    month: parseInt(m[2], 10),
    day: parseInt(m[3], 10),
  };
};
const jsonSchemaPreprocess = (item: any) => {
  const hasOwnProperty = (prop: string) =>
    Object.prototype.hasOwnProperty.call(item, prop);
  if (
    hasOwnProperty("year") &&
    hasOwnProperty("month") &&
    hasOwnProperty("day")
  ) {
    return `${item.year.toString().padStart(4, "0")}-${item.month
      .toString()
      .padStart(2, "0")}-${item.day.toString().padStart(2, "0")}`;
  }
  return item;
};
const schema = z.preprocess(
  preprocess,
  z.object({
    year: z.number(),
    month: z.number(),
    day: z.number(),
  }),
);
const jsonSchema = z.preprocess(
  jsonSchemaPreprocess,
  z
    .string()
    // .regex(regex)
    .nullish()
    .transform((x) => x ?? undefined),
);
export const predefinedYearMonthDayMeta = new ValueObjectMetaComposite<
  typeof schema,
  typeof schema,
  typeof jsonSchema
>(
  "date",
  "日付",
  messageId(predefinedMessageIds.date),
  schema,
  schema,
  schema,
  schema,
  jsonSchema,
  undefined,
  undefined,
  {
    year: undefined,
    month: undefined,
    day: undefined,
  },
);
